import SidebarContentBonus from "./sidebar_content_bonus.png";
import SidebarContentExit from "./sidebar_content_exit.png";
import SidebarContentGameRules from "./sidebar_content_game_rules.png";
import SidebarContentHelp from "./sidebar_content_help.png";
import SidebarContentInvites from "./sidebar_content_invites.png";
import SidebarContentPersonalData from "./sidebar_content_personal_data.png";
import SidebarContentRankings from "./sidebar_content_rankings.png";
import SidebarContentSettings from "./sidebar_content_settings.png";
import SidebarContentShop from "./sidebar_content_shop.png";
import SidebarContentTutorial from "./sidebar_content_tutorial.png";

export {
  SidebarContentBonus,
  SidebarContentExit,
  SidebarContentGameRules,
  SidebarContentHelp,
  SidebarContentInvites,
  SidebarContentPersonalData,
  SidebarContentRankings,
  SidebarContentSettings,
  SidebarContentShop,
  SidebarContentTutorial,
};
